import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAppSelector, useAppDispatch } from '../hooks/redux'
import { getCurrentUser } from '../store/slices/authSlice'

interface AuthGuardProps {
  children: React.ReactNode
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { isAuthenticated, token, user, isLoading } = useAppSelector((state) => state.auth)

  useEffect(() => {
    // If we have a token but no user data, fetch user info
    if (token && !user && !isLoading) {
      dispatch(getCurrentUser())
    }
  }, [dispatch, token, user, isLoading])

  // Show loading spinner while checking authentication
  if (isLoading || (token && !user)) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
